import React from 'react';

export const SkeletonLine = ({ width }: {width: string}) => (
  <span className={`animate-pulse bg-gray-200 dark:bg-gray-700 h-4 ${width} inline-block rounded`} />
);
